// SAD-1005 slice 6: the Dashboard rail's Assist prompts. Templates filled
// from the viewer's own Waiting on You queue, in its order, so the suggestions
// are about this viewer's day; no LLM call on page load. Each starts a chat
// with its prompt (startChat), as a typed one would.
/** The prompt a queue item suggests, by kind; null when it suggests none. */ function fromItem(it) {
    switch(it.kind){
        case 'late':
        case 'overdue':
            if (it.tab === 'corrections' || it.tab === 'issues' || it.tab === 'pursuits') return fromOther(it);
            return it.program ? {
                id: `late:${it.program}`,
                title: `Why is ${it.program} late, and what would fix it?`,
                sub: 'Cites the late deliverables and their owners',
                prompt: `Why is ${it.program} late, and what would fix it?`
            } : null;
        case 'waiting':
            return it.program ? {
                id: `waiting:${it.program}`,
                title: `What is waiting on my approval on ${it.program}?`,
                sub: 'Lists the filings and how long each has waited',
                prompt: `What is waiting on my approval on ${it.program}, and for how long?`
            } : null;
        case 'decision':
            return it.program ? {
                id: `decision:${it.program}`,
                title: `Summarise the ${it.program} go/no-go case`,
                sub: 'Scored factors, incumbent, open risks',
                prompt: `Summarise the ${it.program} go/no-go case.`
            } : null;
        default:
            return fromOther(it);
    }
}
function fromOther(it) {
    if (it.tab === 'corrections' && it.short) {
        return {
            id: `correction:${it.key}`,
            title: `What do I need to do to resolve ${it.short}?`,
            sub: 'Reads the finding, its due date and what closes it',
            prompt: `What do I need to do to resolve ${it.short}?`
        };
    }
    return null;
}
const PROGRAMS_PROMPT = {
    id: 'programs',
    title: 'What changed on my programs since last week?',
    sub: 'Reads filings, decisions and mods on your programs',
    prompt: 'What changed on my programs since last week?'
};
const ANYONE = [
    {
        id: 'cpars',
        title: 'What is a CPARS rating, and how is it scored?',
        sub: 'Plain-language answers to contracting terms',
        prompt: 'What is a CPARS rating, and how is it scored?'
    },
    {
        id: 'document',
        title: 'Summarise a document I upload',
        sub: 'Upload first, then ask',
        prompt: 'I will upload a document. Summarise it, and list its deadlines and obligations.'
    },
    {
        id: 'registries',
        title: 'Find companies in Registries that hold a contract vehicle',
        sub: 'Searches the shared catalogs',
        prompt: 'Which companies in our Registries hold the OASIS+ vehicle?'
    }
];
/** Up to 3 prompts: one per kind from the queue, then the programs, then anyone's. */ export function assistPrompts(ranked, ctx) {
    const out = [];
    const kinds = new Set();
    for (const it of ranked){
        const p = fromItem(it);
        const kind = p?.id.split(':')[0] ?? '';
        if (!p || kinds.has(kind)) continue;
        kinds.add(kind);
        out.push(p);
        if (out.length === 3) return out;
    }
    if (ctx.programs) out.push(PROGRAMS_PROMPT);
    for (const p of ANYONE){
        if (out.length >= 3) break;
        out.push(p);
    }
    return out.slice(0, 3);
}
